<template>
  <div>
    <h4 class="text-heading text-left ml-0 pt-0 mb-2">Testimonials</h4>
    <div class="row">
      <div class="col-8 card-background">
        <p
          class="p-0 m-0 pb-1 pt-3 text-left lato-regular approve-heading text-heading"
        >Approved Testimonials</p>
        <div class="pb-3">
          <div class="table-wrapper-scroll-y my-custom-scrollbar table-responsive">
            <table class="table table-striped mb-0 mt-4">
              <thead>
                <tr>
                  <th class="testimonial-col-width-text">Company Name</th>
                  <th class="testimonial-col-width">Testimonial</th>
                  <th class="testimonial-col-width-text">Effective From</th>
                  <th class="testimonial-col-width-text">Effective Upto</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr v-for="(test,index) in approvedBuyerTestimonials" :key="index">
                  <td class="testimonial-col-width-text">{{test.companyName}}</td>
                  <td class="testimonial-wrap testimonial-col-width">{{test.testimonials}}</td>
                  <td class="testimonial-col-width-text">{{dateFormat(test.effectiveFromDate)}}</td>
                  <td class="testimonial-col-width-text">{{dateFormat(test.effectiveToDate)}}</td>
                </tr>
                <tr v-if="approvedBuyerTestimonials == 0">
                  <td colspan="11" class="m-0 p-0">
                    <div class="m-0 p-3 text-center">No Testimonials Exists for current period</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="col-4 card-background">
        <div class="m-0 text-left">
          <span style="margin-left:10px">
            <p class="pending-font text-heading">Pending for approval</p>
            <p class="p-0 m-0 pb-1 lato-regular duration-font text-heading">Testimonial Duration</p>
            <date-picker
              v-model="validityTimePeriod"
              range
              :lang="'en'"
              confirm
              @confirm="gstEffectiveTimePeriod($event,i)"
              :format="'DD-MMM-YYYY'"
              :shortcuts="false"
              :not-before="defaultEffectiveFrom"
              :not-after="defaultEffectiveAfter"
            ></date-picker>
          </span>
        </div>
        <div class="mt-3" style="width:355px;">
          <div class="card certificate-card mb-4 p-0">
            <div class="m-0 p-0" style="height:100px;background-color:#b4c9f8;"></div>
            <div class="m-0 p-0" style="margin-top:-65px !important;">
              <div
                class="border ml-4 pb-0 pt-3"
                style="width:110px;height:110px;background-color:white;border-radius:49%"
              >
                <img
                  class="card-img"
                  style="width:65%;height:80%;"
                  :src="getCompanyImageLogo(testimonial.testimonialDocId)"
                  width="20px"
                  height="20px"
                />
              </div>
            </div>
            <div class="row m-0 p-0 mt-4">
              <div class="col-2"></div>
              <div class="col-8 text-left ml-n4">
                <img
                  src="@/assets/home-page-images/invertedLeft.png"
                  alt
                  style="height:16px;width:20px;"
                />
              </div>
              <div class="col-2"></div>
            </div>
            <div class="row m-0 p-0">
              <div class="col-2 m-0 p-0"></div>
              <div class="col-8 m-0 p-0">
                <div
                  class="m-0 p-2 ml-2 text-left testimonialsDescription"
                >{{testimonial.testimonials}}</div>
                <div
                  class="m-0 pl-2 ml-2 text-left testimonialsName mt-4"
                >{{testimonial.companyName}}</div>
                <div
                  class="m-0 pl-2 ml-2 text-left testimonialsDesignation"
                >{{testimonial.designation}}</div>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "../../widgets/DatePicker";
import DatePicker from "vue2-datepicker";
import { SummaryServices } from "../../services/summaryService";
import { PartnerService } from "../../services/partnerService";
import moment from "moment";
const SummaryService = new SummaryServices();
const PartnerServices = new PartnerService();
export default {
  name: "Temp",
  components: {
    "w-datepicker": Datepicker,
    DatePicker
  },
  data() {
    return {
      defaultEffectiveFrom: "",
      defaultEffectiveAfter: "",
      validityTimePeriod: [],
      testimonialDuration: {
        effectiveFrom: "",
        effectiveUpto: ""
      },
      testimonial: [],
      imageTempArray: [],
      image: undefined,
      imageBind: []
    };
  },
  props: ["answerNumber"],
  created() {
    console.log("answerNumber", this.answerNumber);
    this.getTestimonials(this.answerNumber);
    this.getApprovedBuyerTestimonilas();
    this.defaultEffectiveFrom = new Date();
    this.defaultEffectiveAfter = "";
    this.validityTimePeriod.push(
      this.defaultEffectiveFrom,
      this.defaultEffectiveAfter
    );
  },
  methods: {
    gstEffectiveTimePeriod(event) {
      this.validityTimePeriod = event;
      this.testimonialDuration.effectiveFrom = event[0].toLocaleDateString();
      this.testimonialDuration.effectiveUpto = event[1].toLocaleDateString();
      this.$emit("testimonialDuration", this.testimonialDuration);
    },
    getCompanyImageLogo(docId) {
      for (let j = 0; j < this.imageBind.length; j++) {
        if (this.imageBind[j].docId == docId) {
          return this.imageBind[j].image;
        }
      }
    },
    getTestimonials(documentNumber) {
      SummaryService.getTestimonialsDetails(documentNumber)
        .then(res => {
          this.testimonial = res.response;
          console.log(this.testimonial);
          let resImage = null;
          let tempImageBind = {
            image: undefined,
            docId: ""
          };
          let docId = res.response.testimonialDocId;
          console.log(docId);
          PartnerServices.downloadCompanyLogo(docId).then(res => {
            this.image = res;
            resImage = this.image;

            var uInt8Array = new Uint8Array(resImage);
            var i = uInt8Array.length;
            var biStr = new Array(i);
            while (i--) {
              biStr[i] = String.fromCharCode(uInt8Array[i]);
            }
            var data = biStr.join("");
            var base64 = window.btoa(data);
            // let tempImage = "data:image/jpeg;base64," + base64;
            this.imageTempArray.push("data:image/jpeg;base64," + base64);
            tempImageBind.image = "data:image/jpeg;base64," + base64;
            tempImageBind.docId = docId;
            this.imageBind.push(tempImageBind);
          });
          console.log(this.imageBind);
        })
        .catch(err => {
          console.log(`Error Occured ${err}`);
        });
    },

    getApprovedBuyerTestimonilas() {
      SummaryService.getApprovedBuyerTestimonials()
        .then(res => {
          this.approvedBuyerTestimonials = res.response;
        })
        .catch(err => {
          console.log(`Error Occured ${err}`);
        });
    },
    dateFormat(date) {
      return moment(date).format("DD-MMM-YYYY");
    }
  }
};
</script>

<style>
.testimonialsName {
  font-size: 18px;
  font-family: "Source Sans Pro", sans-serif;
  line-height: 1.28;
  text-align: right;
  color: #002d72;
  font-weight: bold;
}
.testimonialsDesignation {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  line-height: 1.29;
  text-align: right;
  color: #848484;
}
.testimonialsDescription {
  height: 200px !important;
  font-family: "Source Sans Pro", sans-serif;
}
.approve-testimonial-btn {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 500;
  border-color: none !important;
  color: #ffffff !important;
  width: 164px;
}
.text-heading {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 24px;
  font-weight: 600;
}
.testimonial-wrap {
  word-wrap: break-word;
  width: 10px;
}
.testimonial-col-width {
  width: 10px;
}
.my-custom-scrollbar {
  max-height: 500px;
  width: 100%;
  font-family: "Source Sans Pro", sans-serif;
  overflow: auto;
}
.my-custom-scrollbar thead th {
  position: sticky;
  top: 0;
}
.approve-heading {
  font-size: 20px;
}
.testimonial-col-width-text {
  width: 5px;
}
.pending-font {
  font-size: 20px;
}
.duration-font {
  font-size: 15px;
}
.card-background {
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
</style>
